<label class="app-input-label">
  {{ label }}
</label>
